import React, { ReactText } from 'react';
import styled, { keyframes } from 'styled-components';

const pulse = keyframes`
  0% {
		transform: scale(0.95);
		box-shadow: 0 0 0 0 red;
	}

	70% {
		transform: scale(1);
		box-shadow: 0 0 0 10px rgba(0, 0, 0, 0);
	}

	100% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
	}
`;

const Wrapper = styled.div<Omit<Props, 'backgroundColor'>>`
  margin: 5px;
  display: inline-block;
  border-radius: 50%;
  width: ${(props) => `${props.width}px`};
  height: ${(props) => `${props.width}px`};
`;

const Circle = styled.div<Props>`
  border-radius: 50%;
  width: ${(props) => `${props.width}px`};
  height: ${(props) => `${props.width}px`};
  background-color: ${(props) => props.backgroundColor};
  animation: ${pulse} 1s ease infinite;
`;

interface Props {
  width: ReactText;
  backgroundColor: string;
}

const Pulse: React.FC<Props> = (props) => {
  return (
    <Wrapper width={props.width}>
      <Circle width={props.width} backgroundColor={props.backgroundColor} />
    </Wrapper>
  );
};

export default Pulse;
